import { styled } from '../jss-style';
import textareaStyle from './textarea';

const useTextareaStyle = styled(textareaStyle, 'textarea');
export { textareaStyle, useTextareaStyle };
export default useTextareaStyle;
